// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__0nzCE","loadingRow":"Loading_loadingRow__rfr5f","margin":"Loading_margin__13q9v","value":"Loading_value__y7I62"};